export const UNMARKED_VOTE = 'UNMARKED_VOTE';

export const HELPFUL_VOTE = 'HELPFUL_VOTE';
